module.exports = __webpack_public_path__ + "static/media/d.94c070b4.m4a";